var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style.container }, [
    _vm.showMainNavigation
      ? _c("div", { class: _vm.$style.headerProfile }, [_vm._t("header")], 2)
      : _c("div", { class: _vm.$style.drawerHead }, [
          _c(
            "div",
            {
              class: _vm.$style.backButton,
              on: { click: _vm.handleBackNavigation }
            },
            [
              _c("NsIcon", {
                class: _vm.$style.backIcon,
                attrs: { "icon-name": "icon-narrow-angle-left-24" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { class: _vm.$style.drawerTitle }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.activeNavigation.title || _vm.activeNavigation.name
                ) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              class: _vm.$style.closeButton,
              on: { click: _vm.handleCloseClick }
            },
            [
              _c("NsIcon", {
                class: _vm.$style.closeIcon,
                attrs: { "icon-name": "icon-close-24", size: "custom" }
              })
            ],
            1
          )
        ]),
    _vm._v(" "),
    _c(
      "nav",
      { attrs: { role: "navigation" } },
      [
        _vm.showMainNavigation
          ? _c("div", [
              _c(
                "a",
                {
                  class: _vm.$style.navItem,
                  attrs: { href: _vm.localHomeUrl }
                },
                [
                  _c("span", {
                    class: _vm.$style.navTitle,
                    domProps: { innerHTML: _vm._s(_vm.translations.home) }
                  })
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showSubNavigation
          ? [
              _vm._l(_vm.activeNavigation.subnav, function(navItem, navIndex) {
                return _c(
                  "div",
                  {
                    key: navItem.title || navItem.name,
                    class: _vm.$style.navItem
                  },
                  [
                    _vm.allowSubNavigation(navItem)
                      ? _c(
                          "a",
                          {
                            class: _vm.$style.navItem,
                            attrs: { href: "javascript:void(0)" },
                            on: {
                              click: function($event) {
                                return _vm.selectSubNavigation(navIndex)
                              }
                            }
                          },
                          [
                            _c("span", { class: _vm.$style.navTitle }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(navItem.title || navItem.name) +
                                  "\n          "
                              )
                            ]),
                            _vm._v(" "),
                            _c("NsIcon", {
                              class: _vm.$style.navIcon,
                              attrs: { "icon-name": "icon-direction-mc" }
                            })
                          ],
                          1
                        )
                      : _c(
                          "a",
                          {
                            class: _vm.$style.navItem,
                            attrs: { href: navItem.href }
                          },
                          [
                            _c("span", { class: _vm.$style.navTitle }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(navItem.title || navItem.name) +
                                  "\n          "
                              )
                            ])
                          ]
                        )
                  ]
                )
              }),
              _vm._v(" "),
              _vm.showSeeAllLink
                ? _c("div", [
                    _c(
                      "a",
                      {
                        class: _vm.$style.navItem,
                        attrs: { href: _vm.activeNavigation.href }
                      },
                      [
                        _c("span", { class: _vm.$style.navTitle }, [
                          _vm._v(_vm._s(_vm.activeCategoryLinkText))
                        ])
                      ]
                    )
                  ])
                : _vm._e()
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.showMainNavigation
          ? [
              _vm.joinUs.label && _vm.joinUs.link
                ? _c("div", [
                    _c(
                      "a",
                      {
                        class: _vm.$style.navItem,
                        attrs: { href: _vm.joinUs.link }
                      },
                      [
                        _c("span", { class: _vm.$style.navTitle }, [
                          _vm._v(_vm._s(_vm.joinUs.label))
                        ])
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.limitedLegalLinks, function(link) {
                return _c("div", { key: link.name }, [
                  _c(
                    "a",
                    { class: _vm.$style.navItem, attrs: { href: link.href } },
                    [
                      _c("span", { class: _vm.$style.navTitle }, [
                        _vm._v(_vm._s(link.name))
                      ])
                    ]
                  )
                ])
              })
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.activeNavigationCustomComponent
          ? _c(
              "div",
              [
                _c("NsDynamicHtml", {
                  attrs: { template: _vm.activeNavigationCustomComponent }
                })
              ],
              1
            )
          : _vm._e()
      ],
      2
    ),
    _vm._v(" "),
    _vm.showMainNavigation
      ? _c("div", { class: _vm.$style.secondaryActions }, [
          _c(
            "div",
            { class: _vm.$style.regionSelector },
            [
              _c("NsMinimalHeaderRegionSelector", {
                attrs: {
                  "href-override": _vm.homeUrl,
                  region: _vm.region,
                  "region-selector-path": _vm.regionSelectorPath,
                  translations: _vm.translations
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.isLoggedIn
            ? _c(
                "div",
                { class: _vm.$style.signOutLink, on: { click: _vm.signOut } },
                [_c("span", [_vm._v(_vm._s(_vm.translations.signOutLabel))])]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isLoggedIn
            ? _c("div", { class: _vm.$style.signOutLink }, [
                _c("span", { on: { click: _vm.signIn } }, [
                  _vm._v(_vm._s(_vm.translations.signInLabel))
                ]),
                _vm._v(" "),
                _c("span", { class: _vm.$style.slash }, [_vm._v("/")]),
                _vm._v(" "),
                _c("span", { on: { click: _vm.signUp } }, [
                  _vm._v(_vm._s(_vm.translations.signUpLabel))
                ])
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.showFooterNav
      ? _c("div", { class: _vm.$style.footerNav }, [
          _c("div", { class: _vm.$style.footerNavHead }, [
            _c("button", {
              staticClass: "ghost-inverse fluid",
              domProps: {
                innerHTML: _vm._s(_vm.translations.sendSignupInvite)
              },
              on: { click: _vm.handleFooterSignupClick }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.$style.footerNavBody },
            [
              _c("NsFooterNav", {
                attrs: {
                  navigation: _vm.footerNavigation,
                  expandbreakpoint: "none"
                }
              })
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }